import React from 'react'
import Banner from './banner'
import DiningRoll from './dining-roll'
import DiningCta from './dining-cta'
import CurrentPromotions from './current-promotions'
import Search from './search'
import HotelRooms from './hotel-rooms'
import HotelAmenities from './page-list/hotel-amenities'
import SpaMenus from './spa-menus'


export default function FeaturedItems({ props, mobileIndex, lastSection, location }) {
  const { type, heading, content, cta, image, diningList, diningListOptions, featuredDiningOption, } = props
  const singleDining = type === "singleDining" && featuredDiningOption ?
    {
      subheading: featuredDiningOption.title,
      content: featuredDiningOption.excerpt,
      cta: {
        url: featuredDiningOption.uri,
        title: featuredDiningOption.dining?.card?.buttonTitle || "View More",
      },
      image: image || featuredDiningOption.featuredImage?.node,
      icon: featuredDiningOption.dining?.logo,
      hours: featuredDiningOption.dining?.hours,
      background: "shadow",
    } : false
  const multipleDining = type === "multipleDining" ?
    {
      heading: heading,
      content: content,
      cta: cta,
      diningList: diningList,
      options: diningListOptions,
    } : false
  const diningCta = type === "diningCta"
  const currentPromotions = type === "currentPromotions"
  const searchIndices = type === "upcomingEvents" ? [{ name: `Events`, title: `Events` }] : type === "news" ? [{ name: `Posts`, title: `Posts` }] : null
  const hotelRooms = type === "hotelRooms" ? { heading: heading, content: content } : null
  const hotelAmenities = type === "hotelAmenities"
  const spaMenus = type === "spaMenus" ? { heading: heading, content: content } : null
  return (
    <>
      {singleDining ?
        <Banner props={singleDining} mobileIndex={mobileIndex} />
        : multipleDining ?
          <DiningRoll props={multipleDining} />
          : diningCta ?
            <DiningCta />
            : currentPromotions ?
              <CurrentPromotions />
              : searchIndices ?
                <Search indices={searchIndices} props={{ heading: heading }} location={location} />
                : hotelRooms ?
                  <HotelRooms props={hotelRooms} />
                  : hotelAmenities ?
                    <HotelAmenities exclude={location.pathname} />
                    : spaMenus ?
                      <SpaMenus props={spaMenus} />
                      : null}
    </>
  )
}
